import { ReactNode } from "react";

interface LucideIconProps {
  children: ReactNode;
  size?: number;
}

/**
 * Wrapper component for Lucide icons to maintain consistent sizing with Ant Design icons
 */
export const LucideIcon = ({ children, size: _size = 16 }: LucideIconProps) => (
  <span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
    {children}
  </span>
);





